import { useState, useCallback, useRef, useEffect } from 'react';

function useCountdownTimer(_a) {
    var timer = _a.timer, _b = _a.interval, interval = _b === void 0 ? 1000 : _b, _c = _a.autostart, autostart = _c === void 0 ? false : _c, _d = _a.expireImmediate, expireImmediate = _d === void 0 ? false : _d, onExpire = _a.onExpire, onReset = _a.onReset;
    var _e = useState(timer), countdown = _e[0], setCountdown = _e[1];
    var _f = useState(autostart), canStart = _f[0], setCanStart = _f[1];
    function start() {
        setCanStart(true);
    }
    var reset = useCallback(function () {
        setCanStart(false);
        setCountdown(timer);
        if (onReset && typeof onReset === 'function') {
            onReset();
        }
    }, [timer, onReset]);
    var expire = useCallback(function () {
        setCanStart(false);
        setCountdown(timer);
        if (onExpire && typeof onExpire === 'function') {
            onExpire();
        }
    }, [timer, onExpire]);
    var countdownRef = useRef(timer);
    useEffect(function () {
        countdownRef.current = countdown;
    }, [countdown]);
    useEffect(function () {
        function tick() {
            if (countdownRef.current / 1000 <= 0 ||
                (expireImmediate && (countdownRef.current - interval) / 1000 <= 0)) {
                expire();
            }
            else {
                setCountdown(function (prev) { return prev - interval; });
            }
        }
        var id;
        if (canStart) {
            id = setInterval(tick, interval);
        }
        return function () { return clearInterval(id); };
    }, [expire, canStart, interval, expireImmediate]);
    return {
        countdown: countdown,
        start: start,
        reset: reset,
    };
}

export { useCountdownTimer };
//# sourceMappingURL=index.es.js.map
